import axiosInstance from '@/utils/httpUtil'
import { setting } from '@/setting'

const adminBaseUrl = setting.adminBaseUrl

export const materialApi = {
  // 获取资料列表
  getMaterials: (page, pageSize) => {
    return axiosInstance.get(
      `${adminBaseUrl}/studyMaterials/?page=${page}&pageSize=${pageSize}`
    )
  },
  // 其他 API 方法可以在这里添加
  getMaterialDetails: (id) => {
    return axiosInstance.get(`${adminBaseUrl}/studyMaterials/${id}`);
  },
  
  getCategories: () => {
    return axiosInstance.get(`${adminBaseUrl}/studyMaterials/categories`);
  },

  getTags: () => {
    return axiosInstance.get(`${adminBaseUrl}/studyMaterials/tags`);
  },

  createTag: ({name}) => {
    return axiosInstance.post(
      `${adminBaseUrl}/studyMaterials/tag`,
      {
        name: name,          // 标签名称
      }
    )
  },

  updateTag: ({id, name}) => {
    return axiosInstance.put(
      `${adminBaseUrl}/studyMaterials/tag/${id}`, // 注意URL路径格式
      {
        name: name,          // 标签名称
      }
    )
  },

  deleteTag: (id) => {
    return axiosInstance.delete(`${adminBaseUrl}/studyMaterials/tag/${id}`)
  },

  // 新增分类更新方法
  updateCategory: ({ id, name, areaType }) => {
    return axiosInstance.put(
      `${adminBaseUrl}/studyMaterials/category/${id}`, // 注意URL路径格式
      {
        name: name,          // 分类名称
        areaType: areaType   // 地区类型参数
      }
    )
  },

  createCategory: ({name, areaType}) => {
    return axiosInstance.post(
      `${adminBaseUrl}/studyMaterials/category`,
      {
        name: name,          // 分类名称
        areaType: areaType   // 地区类型参数
      }
    )
  },

  updateMaterial: (id, data) => {
    const { newCategoryId, visible, addTagIds, removeTagIds, file } = data;
    const url = `${adminBaseUrl}/studyMaterials/${id}?newCategoryId=${newCategoryId}&visible=${visible}`;
    const formData = new FormData();
    if (file) {
      formData.append('file', file);
    }
    // Append tags to formData if needed
    addTagIds.forEach(tag => formData.append('addTagIds[]', tag));
    removeTagIds.forEach(tag => formData.append('removeTagIds[]', tag));
    return axiosInstance.put(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  createMaterial: (categoryId, data) => {
    const { tagId, uploadDate, visible, file } = data;

    // 构造 URL，确保参数正确拼接
    const url = new URL(`${adminBaseUrl}/studyMaterials/${categoryId}`);
    url.searchParams.append("tagId", tagId);
    url.searchParams.append("visible", visible);
    if (uploadDate !== undefined && uploadDate !== null) {
      url.searchParams.append("uploadDate", encodeURIComponent(uploadDate));
    }

    // 构造 FormData
    const formData = new FormData();
    if (file) {
        formData.append("file", file);
    }
    return axiosInstance.post(url.toString(), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
    });
  },
} 